import Hammer from "hammerjs";
import { bindHammerSwipe } from "./hammer_gestures";

declare global {
  interface Window {
    __WMU_MOBILE_GESTURES_BOOTED?: boolean;
  }
}

const doc = document;

function resolveThreshold(panel: HTMLElement): number {
  const rawThreshold = Number.parseFloat(panel.getAttribute("data-swipe-threshold") || "10");
  const threshold = Number.isFinite(rawThreshold) && rawThreshold > 0 ? rawThreshold : 10;
  const unit = panel.getAttribute("data-swipe-unit") || "px";
  if (unit === "vh") {
    return Math.round((threshold / 100) * document.documentElement.clientHeight);
  }
  if (unit === "vw") {
    return Math.round((threshold / 100) * document.documentElement.clientWidth);
  }
  return threshold;
}

function bindSwipeToDismiss(root: ParentNode): void {
  root.querySelectorAll("[data-gesture-dismiss]").forEach((panel) => {
    if (!(panel instanceof HTMLElement)) return;
    if (panel.dataset.gestureDismissBound === "true") return;
    panel.dataset.gestureDismissBound = "true";
    if (!panel.hasAttribute("data-swipe-threshold")) {
      panel.setAttribute("data-swipe-threshold", "10");
      panel.setAttribute("data-swipe-unit", "vh");
    }
    if (!panel.hasAttribute("data-swipe-timeout")) {
      panel.setAttribute("data-swipe-timeout", "700");
    }
    bindHammerSwipe(
      panel,
      {
        down: () => {
          panel.dispatchEvent(new CustomEvent("wmu:gesture-dismiss", { bubbles: true }));
        },
      },
      {
        direction: Hammer.DIRECTION_DOWN,
        threshold: resolveThreshold(panel),
        touchAction: "pan-x",
      },
    );
  });
}

export function initMobileGestures(root: ParentNode = doc): void {
  bindSwipeToDismiss(root);
}

function boot(): void {
  if (window.__WMU_MOBILE_GESTURES_BOOTED) return;
  window.__WMU_MOBILE_GESTURES_BOOTED = true;
  initMobileGestures(doc);
  doc.body.addEventListener("htmx:afterSwap", (event) => {
    const target = (event as CustomEvent<{ target?: EventTarget | null }>).detail?.target;
    if (target instanceof HTMLElement) {
      initMobileGestures(target);
      return;
    }
    initMobileGestures(doc);
  });
}

if (doc.readyState === "loading") {
  doc.addEventListener("DOMContentLoaded", boot);
} else {
  boot();
}
